import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Route,
  withRouter,
  Redirect,
} from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { UserService } from '@pingum/api-services';

import { getTenantFromUrl } from '../../../utils/urlHelper';
import { getBillingInformation } from '../../../utils/pricingHelper';
import * as authActions from '../../../redux/auth/actions';
import propTypes from '../../../utils/propTypes';

const isUserInTenant = (userTenants, tenant) => userTenants.indexOf(tenant) > -1;

export class PrivateRouteComponent extends React.Component {
  constructor(props) {
    super(props);
    if (!props.auth.isAuthenticated) {
      props.loginRequest();
    }
  }

  handleRender = (props) => {
    const {
      component: Component,
      auth: { isAuthenticated },
      user,
      path,
      userTenants,
      tenant: tenantObject,
    } = this.props;
    const tenant = getTenantFromUrl();
    const billingInformation = getBillingInformation(tenantObject);

    if (isAuthenticated && tenant && !isUserInTenant(userTenants, tenant)) {
      return <Redirect to="/access-denied" />;
    }

    if (isAuthenticated && tenant && tenantObject.deactivated) {
      return <Redirect to="/deactivated-organization" />;
    }

    // TODO sometimes the tenant object isn't populated yet so if on fresh page load user getting directed to invalid payment page. For now
    // if that object is empty we will just let them through, they will get invalid page on next page load if really invalid
    const hasAppAccess = billingInformation.isOnFreeTrial || billingInformation.hasValidPaidPlan || (!tenantObject || !tenantObject.id);
    const roles = UserService.getUserRolesForTenant(user, tenantObject.name);
    const isOwner = roles.indexOf('owner') > -1;

    if (isAuthenticated && (path === '/organizations' || (hasAppAccess || (isOwner && path === '/settings/billing')))) { // let owners get to billing page
      // on free trial or paying for plan so let through...
      return <Component {...props} />;
    }

    // Not on a free trial and there is no valid payment method
    if (isOwner) {
      // User is owner so take them to the billing page
      return <Redirect to="/settings/billing" />;
    }
    // Not owner so show trial expired page
    return <Redirect to="/invalid-payment" />;

    // return <Redirect to="/" />;
  }

  render() {
    const {
      title,
      tenant,
      component,
      ...rest
    } = this.props;

    return (
      <div>
        <Helmet>
          <title>{`${title
            ? `${title} | `
            : ''}${tenant.displayName} | Pingum`}
          </title>
        </Helmet>
        {
          this.props.user
            && (
              <Route
                {...rest}
                render={this.handleRender}
              />
            )
        }
      </div>
    );
  }
}

PrivateRouteComponent.propTypes = {
  component: PropTypes.any.isRequired,
  auth: PropTypes.shape({ isAuthenticated: PropTypes.bool.isRequired }).isRequired,
  loginRequest: PropTypes.func.isRequired,
  user: PropTypes.shape(propTypes.user),
  path: PropTypes.string,
  userTenants: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string,
  tenant: PropTypes.object,
};

PrivateRouteComponent.defaultProps = {
  user: null,
  userTenants: [],
  title: '',
  path: '',
  tenant: {},
};

export const mapDispatchToProps = (dispatch) => ({
  loginRequest: () => {
    dispatch(authActions.loginRequest());
  },
});

export const mapStateToProps = (state) => ({
  auth: state.auth,
  user: state.user.user,
  userTenants: state.user.tenants.map((tenant) => tenant.name),
  tenant: state.tenant.tenant,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateRouteComponent));
